/**
 * 로봇 기준일 마감본(회계용) — plan docs/plan/robot-asof-snapshot-2026-10.
 *
 * 로봇 목록을 어느 시각 그대로 얼려 둔 것. 서버(찍기·조회·크론)와 콘솔(기준일 고르기·띠)이 같은
 * 이름표·판정을 쓰도록 여기 한 벌로 둔다.
 */
import { kstMonthRangeUtc, kstTodayYmd, kstYmdHyphen, kstYmdRangeUtc } from './kst.js';
/** 출처 세 가지 — DB CHECK(RobotListSnapshot_source_check)와 같은 목록. */
export const ROBOT_LIST_SNAPSHOT_SOURCES = ['CRON', 'MANUAL', 'BACKFILL_PITR'];
/** 화면 띠·고르기에 적는 출처 이름. */
export const ROBOT_LIST_SNAPSHOT_SOURCE_LABELS = {
    CRON: '말일 자동 마감',
    MANUAL: '관리자 지금 마감',
    BACKFILL_PITR: '백업 복원',
};
/**
 * summary JSON(그때의 로봇 목록 DTO) 모양의 판. 목록 DTO 가 바뀌어 옛 행을 다르게 읽어야 하면 올린다.
 */
export const ROBOT_LIST_SNAPSHOT_SCHEMA_VERSION = 1;
/**
 * 그 순간의 KST 날짜가 그달 마지막 날인가(다음 KST 날이 1일이면 말일).
 *
 * 크론 표현식에 '말일'(L)이 없어(cron 3.2.1) 28~31일에 돌고 여기서 가른다. 서버는 UTC 로 돌므로
 * 로컬 Date 부품을 쓰지 않고 KST 날짜 문자열에서 계산한다.
 */
export function isKstLastDayOfMonth(now) {
    // 한국은 일광 절약 시간이 없어 KST 하루는 언제나 24시간이다 — 24시간 뒤의 KST 날짜가 1일이면 말일.
    const t = typeof now === 'number' ? now : now.getTime();
    return kstTodayYmd(t + 86_400_000).endsWith('-01');
}
/**
 * 'YYYY-MM-DD' 가 **있는 날짜**인가 — 모양만 맞는 2026-02-30 은 DATE 로 넣으면 3/2 가 되어 다른 날의
 * 마감본을 연다(2026-10-08 외부 검토). 그 날짜의 자정(UTC)을 KST 날짜로 다시 읽어 같은 글자가 나오는지
 * 본다(자정 UTC = 같은 날 09:00 KST). 서버(400)와 콘솔('지금'으로 연다)이 같은 판정을 쓴다.
 */
export function isRealYmd(ymd) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd))
        return false;
    return kstYmdHyphen(new Date(`${ymd}T00:00:00.000Z`)) === ymd;
}
/** KST 달력일 `YYYY-MM-DD` 의 배타적 끝 순간(다음 날 00:00 KST). 9/30 → 2026-09-30T15:00:00Z. */
export function kstEndOfDayUtc(ymd) {
    return kstYmdRangeUtc(ymd, ymd)?.endUtc ?? null;
}
/** 직전 달의 말일(KST) `YYYY-MM-DD` — 1일 아침 점검이 "지난달 마감본이 있나"를 볼 때. */
export function kstPreviousMonthLastDay(now) {
    // 이번 KST 달이 시작하기 1ms 전 순간의 KST 날짜 = 지난달 말일.
    const start = kstMonthRangeUtc(now).startUtc.getTime();
    return kstYmdHyphen(start - 1) ?? '';
}
//# sourceMappingURL=robot-snapshot.js.map